import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export function RecommendationDonut({ data }) {
  const total = data.reduce((a, d) => a + d.count, 0);
  if (total === 0) {
    return <div className="text-sm text-slate-400 py-8 text-center">Noch keine ausgewerteten Ergebnisse im Zeitraum.</div>;
  }
  return (
    <ResponsiveContainer width="100%" height={260}>
      <PieChart>
        <Pie data={data} dataKey="count" nameKey="label" innerRadius={60} outerRadius={90} paddingAngle={2}>
          {data.map((entry, i) => <Cell key={i} fill={entry.color} />)}
        </Pie>
        <Tooltip formatter={(v, name) => [`${v} Ergebnisse`, name]} />
        <Legend formatter={(value) => {
          const row = data.find(d => d.label === value);
          return `${value} – ${row ? row.pct : 0}%`;
        }} />
      </PieChart>
    </ResponsiveContainer>
  );
}
